// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"3010db35","130":"06e662ba"}[chunkId] + ".chunk.js";
};